import { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../components/ui/ConfirmDialog';

// Promise-based replacement for window.confirm, backed by <ConfirmDialog>.
// Usage: const { confirm, confirmDialog } = useConfirm();
//        if (!(await confirm('Delete this item?'))) return;
//        return <>...{confirmDialog}</>
export function useConfirm() {
  const [request, setRequest] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setRequest({ message, options });
    });
  }, []);

  const handleClose = useCallback(() => {
    setRequest(null);
    resolveRef.current?.(false);
    resolveRef.current = null;
  }, []);

  const handleConfirm = useCallback(() => {
    resolveRef.current?.(true);
    resolveRef.current = null;
  }, []);

  const confirmDialog = (
    <ConfirmDialog
      isOpen={!!request}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={request?.options?.title || 'Confirm'}
      description={request?.message || ''}
      confirmText={request?.options?.confirmText}
      cancelText={request?.options?.cancelText}
      isDestructive={request?.options?.isDestructive ?? true}
    />
  );

  return { confirm, confirmDialog };
}
